<template>
  <div>
    <v-dialog v-if="showDialog" @keydown.esc="closeDialog" v-model="showDialog" :width="getWidth" persistent scrollable>
        <v-card class="">
            <v-card-text class="p-5">

                <div class="d-flex justify-center pb-4">
                    <div :class="(dialog.picto == '' ? 'alert-avertissement' : dialog.picto)"></div>
                </div>

                <div v-html="dialog.label" class="pb-4 text-center"></div>

                <v-row class="m-0 d-flex justify-center">
                    <div v-for="(button, index) in dialog.buttons" :key="index">
                        <div  v-if="button !=''"  class="px-2">
                            <loader-button :label="button" @callback="handleUserInput(button, null)"></loader-button>
                        </div>
                    </div>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
  </template>
  
<script lang="ts">
import Dialog from '@/generated/classes/Dialog';
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import { RessourceFwkButton, FwkButtons } from '@/ressources/globalRessources';
import { defineComponent } from "vue";

export interface OpenAlert {
    (dialog: Dialog): Promise<string>;
}

export let openAlert: OpenAlert | undefined = undefined;
export function setOpenAlert(fct: OpenAlert): void {
    openAlert = fct;
}
export default defineComponent({
    components: {
        LoaderButton
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown)
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onKeydown)
    },
    data() {
        const resolvePromise = undefined as ((value: PromiseLike<string> | string) => void) | undefined;

        return {
            dialog: new Dialog(),
            showDialog: false,
            resolvePromise,
            openAlert
        };
    },
    
    computed: {
        getWidth(): number {
            return 500;
        }
    },

    methods: {
        onKeydown(event: KeyboardEvent) {
            if (event.key == 'Enter' || event.key == 'Escape') {
                event.stopPropagation();
                this.handleUserInput("", event);
            }
        },
        openModal(dialog: Dialog): Promise<string> {
            this.showDialog = true
            this.dialog = dialog;
            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
        handleUserInput(value: string, event: KeyboardEvent | null) {
            if (this.resolvePromise) {
                if (event && event.key) {
                    if (event.key == 'Enter') {
                        this.resolvePromise(RessourceFwkButton(FwkButtons.CONFIRMER).label);
                    } else if (event.key == 'Escape') {
                        this.resolvePromise(RessourceFwkButton(FwkButtons.ANNULER).label);
                    }
                } else {
                    this.resolvePromise(value);
                }
            }
            this.showDialog = false;
        },
        closeDialog() {
            this.showDialog = false;
        }
    }
})

</script>